module.exports = __webpack_public_path__ + "img/hack_3.4c696d4a.png";